export enum CampaignType {
    Project = "Project",
    Individual = "Individual",
    Sport = "Sport",
    Outing = "Outing",
    Scholarship = "Scholarship",
    Other = "Other"
}